<template>
  <div v-for="(price, index) in pricing" :key="index" class="col-lg-4">
      <div class="pricing-item">
          <div class="pricing-wrap">
              <div class="pricing-info">
                  <span class="price">{{price.value}}</span>
              </div>
          </div>
          <div class="pricing-list-wrap">
              <p style="font-weight:bold; color:black">
                {{price.tag}}</p>
              <h2 class="pricing-title">{{price.title}}</h2>
              <ul class="pricing-list style-2">
                  <li v-for="(list, index) in price.lists" :key="index">
                    <p  :class=list.css><i :class="list.icon"></i>{{list.text}}</p>
                  </li>
              </ul>
              <div class="pricing-btn-wrap">
                  <a class="btn btn-custom-size btn-outline" target=”_blank” :href=price.file>
                    Regolamento 
                      <i class="icofont-double-right"></i>
                  </a>
              </div>
              
          </div>
      </div>
  </div>
</template>

<style>
  .rtext{
    font-weight:bold;
  }
</style>
<script>
export default {
data () {
  return {
    pricing: [
      {
        value: '€30',
        tag:'Iscrizione mezzi',
        title: 'Best Truck',
        file: 'doc/Best_Truck.pdf',
        lists: [
          {
            text: " Esponi il tuo mezzo nell'area dedicata e vinci il titolo del mezzo più bello",
            css: ''
          },
          {
            text: ' Requisiti: ',
            css: 'rtext'
          },
          {
            icon:'icofont-check-alt',
            text: 'Mezzo a norma',
            css: ''
          }
        ]
      },
      {
        value: '€30',
        tag: 'Prove a tempo',
        title: 'Gran Prix',
        file: 'doc/Gran_Prix.pdf',
        lists: [
          {
            text: ' La gara consiste in un percorso a slalom tra birilli con manovra di parcheggio in retromarcia da eseguire con trattore e semirimorchio agganciato.',
            css: ''
          },
          {
            text: ' Requisiti: ',
            css: 'rtext'
          },
          {
            icon:'icofont-check-alt',
            text: 'Patente di guida valida',
            css: ''
          },
          {
            icon:'icofont-check-alt',
            text: 'Trattore a norma',
            css: ''
          }
        ]
      },
      {
        value: '€30',
        tag: 'Prove a tempo',
        title: 'Truck Pulling',
        file: 'doc/Truck_Pulling.pdf',
        lists: [
          {
            text: ' La prova consiste nel trainare un rimorchio zavorato con 450 qli su un tratto rettilineo con leggera pendenza nel minor tempo possibile.',
            css: ''
          },
          {
            text: ' Requisiti: ',
            css: 'rtext'
          },
          {
            icon:'icofont-check-alt',
            text: 'Patente di guida valida',
            css: ''
          },
          {
            icon:'icofont-check-alt',
            text: 'Trattore a norma',
            css: ''
          }
        ]
      },      
    ]
  }
}
}
</script>
